import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {HttpClient} from "@angular/common/http";

export enum ReservationType {
  ALL = 'all', UPCOMING = 'upcoming', COMPLETED = 'completed'
}

export enum ReservationStatus {
  CONFIRMED = 'C',
  WAITING = 'W',
  UNAVAILABLE = 'U',
}

export interface ReservationAddress {
  readonly town: string;
  readonly address: string;
  readonly postcode: string;
}

export interface ReservationCustomer {
  readonly name: string;
  readonly phone: string;
}

export interface ReservationItem {
  readonly quantity: string;
  readonly type: string;
  readonly description: string;
}

export interface ReservationSummary {
  readonly comment: string
}

export interface Reservation {
  readonly id: number;
  readonly title: string;
  readonly description: string;
  readonly party_size: number;
  readonly time_from: Date;
  readonly time_to: Date;
  readonly address: ReservationAddress;
  readonly customer: ReservationCustomer;
  readonly items: ReservationItem[];
  readonly remarks: string;
  readonly status: ReservationStatus;
  readonly is_paid: boolean;
  readonly is_past: boolean;
  readonly total_price: string;
  readonly chef_contacted_customer: boolean;
  readonly chef_should_contact_with_customer: boolean;
  readonly chef_can_submit_summary: boolean;
}

@Injectable()
export class ReservationsService {

  constructor(private http: HttpClient) {
  }

  getReservationsList(type: ReservationType): Observable<Reservation[]> {
    return this.http.get<Reservation[]>('/reservations', {params: {type: type}});
  }

  getReservationsDetails(reservationId: number): Observable<Reservation> {
    return this.http.get<Reservation>(`/reservations/${reservationId}`);
  }

  confirmReservation(reservationId: number): Observable<any> {
    return this.http.patch(`/reservations/${reservationId}`, {status: ReservationStatus.CONFIRMED});
  }

  rejectReservation(reservationId: number): Observable<any> {
    return this.http.patch(`/reservations/${reservationId}`, {status: ReservationStatus.UNAVAILABLE});
  }

  confirmContact(reservationId: number): Observable<any> {
    return this.http.patch(`/reservations/${reservationId}`, {chef_contacted_customer: true});
  }

  submitSummary(reservationId: number, summary: ReservationSummary): Observable<any> {
    return this.http.post(`/reservations/${reservationId}/summary`, {comment: summary.comment});
  }

}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/services/reservations.service.ts